import { StorageError } from "@/infrastructure/errors/StorageError";

export class SessionStorageManager {
  constructor(private readonly prefix: string = "") {}

  private getKey(key: string): string {
    return this.prefix ? `${this.prefix}:${key}` : key;
  }

  get(key: string): string | null {
    try {
      return sessionStorage.getItem(this.getKey(key));
    } catch (error) {
      const message = error instanceof Error ? error.message : "Unknown error";
      throw new StorageError(`Failed to retrieve data from sessionStorage: ${message}`);
    }
  }

  set(key: string, value: string): void {
    try {
      sessionStorage.setItem(this.getKey(key), value);
    } catch (error) {
      const message = error instanceof Error ? error.message : "Unknown error";
      throw new StorageError(`Failed to store data in sessionStorage: ${message}`);
    }
  }

  delete(key: string): void {
    try {
      sessionStorage.removeItem(this.getKey(key));
    } catch (error) {
      const message = error instanceof Error ? error.message : "Unknown error";
      throw new StorageError(`Failed to delete data from sessionStorage: ${message}`);
    }
  }
}
